import client from './client';

// S5：人工客服一次性 supportToken（widget 换取已登录用户档案，短时效）
export async function fetchSupportToken(): Promise<{ token: string; expiresIn: number }> {
  const { data } = await client.post('/auth/support-token');
  return data;
}
